import { LESSON_TYPES } from './lessonTypes';

export const INSTRUCTOR_REQUIRED_LESSON_TYPES = [LESSON_TYPES.liveLecture];
